goog.provide("shadow.js.shim.module$penpal");
goog.provide("module$shadow_js_shim_module$penpal");
shadow.js.shim.module$penpal = shadow.js.nativeProvides["penpal"] = shadow$bridge("penpal");
module$shadow_js_shim_module$penpal.default = shadow.js.shim.module$penpal;
